import styled from 'styled-components';

export const AboutContainer = styled.div`
  display: flex;
  min-height: auto;
  width: 100vw;
  position: relative;
  padding-bottom: 50px;

  @media (max-width: 840px) {
    padding-bottom: 40px;
  }

  @media (max-width: 440px) {
    min-height: auto;
    padding-bottom: 30px;
  }
`;

export const Logo = styled.div`
  position: absolute;
  top: -30px;
  left: 40px;
`;

export const Paragraph = styled.p`
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: 3px;
`;

export const Title = styled.h2`
  margin-top: 60px;
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: 3px;
`;

export const Subtitle = styled.h3`
  margin-top: 20px;
  font-size: 1.5rem;
  font-weight: 900;
  letter-spacing: 3px;
`;

export const Text = styled.p`
  margin-top: 10px;
  font-weight: 300;
  line-height: 1.5em;
  letter-spacing: 0.05rem;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 50px;
  margin: 0 auto;
  height: auto;
  width: 70%;
  gap: 30px;
  @media (max-width: 1200px) {
    width: 90%;
  }
  @media (max-width: 840px) {
    display: flex;
    justify-content: start;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin: 0 20px;
    padding-top: 80px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const AboutUsContainer = styled.div`
  display: flex;
  gap: 100px;
  @media (max-width: 840px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

export const ChildDiv = styled.div`
  flex: 1;
`;

export const AboutImage = styled.img`
  display: block;
  width: 100%;
  max-width: 700px;
  height: auto;
  border-radius: 8px;
  margin: 20px auto 10px auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
`;

export const FullWidthSection = styled.div`
  width: 100%;
  margin-bottom: 40px;

  @media (max-width: 840px) {
    margin-bottom: 30px;
  }
`;

export const TwoColGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: start;
  gap: 50px;

  @media (max-width: 840px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

export const LeftCol = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

export const RightCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const TopGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
  gap: 40px;

  @media (max-width: 840px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

export const ReasonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const PersonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 12px;
`;
